import React from "react";

export default function KpiTile({ label, value, sub, accent = false, tone, testid, icon: Icon }) {
  const toneColor =
    tone === "profit" ? "#2ECA7F"
    : tone === "loss" ? "#FF4D4D"
    : tone === "info" ? "#60A5FA"
    : tone === "hof" ? "#D6FF38"
    : tone === "basic" ? "#22C55E"
    : tone === "warn" ? "#F97316"
    : accent ? "#D6FF38"
    : "#F1F5F9";
  // Border/glow tint that matches the value color, subtle enough to keep
  // the dark aesthetic intact.
  const borderTint =
    tone === "profit" ? "rgba(46,202,127,0.28)"
    : tone === "loss" ? "rgba(255,77,77,0.28)"
    : tone === "info" ? "rgba(96,165,250,0.28)"
    : tone === "hof" ? "rgba(214,255,56,0.28)"
    : tone === "basic" ? "rgba(34,197,94,0.28)"
    : tone === "warn" ? "rgba(249,115,22,0.30)"
    : accent ? "rgba(214,255,56,0.28)"
    : "#2A2D3A";
  return (
    <div
      data-testid={testid}
      className="relative border rounded-md p-4 bg-[#15171E] hover:bg-[#181A22] transition-colors overflow-hidden"
      style={{ borderColor: borderTint }}
    >
      {/* Left accent bar - subtle visual pop */}
      <div className="absolute inset-y-0 left-0 w-[3px]" style={{ background: toneColor, opacity: 0.55 }} />
      <div className="flex items-center justify-between pl-1">
        <div className="text-[10px] mono uppercase tracking-widest text-[#94A3B8]">{label}</div>
        {Icon && <Icon size={14} weight="duotone" style={{ color: toneColor, opacity: 0.85 }} />}
      </div>
      <div className="mt-2 mono text-2xl font-medium tracking-tight pl-1" style={{ color: toneColor }}>
        {value}
      </div>
      {sub && <div className="mt-1 text-[11px] text-[#CBD5E1] pl-1">{sub}</div>}
    </div>
  );
}
